module.exports = __webpack_public_path__ + "static/greenchickchop_logo-77353a2589d14cb229d8ae28ce7b5edb.png";